import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { IPopupScreenData } from 'src/app/common/models/popup-screen-data.model';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoanTransactionDetail } from 'src/app/models/loan-transaction-detail.model';

@Component({
  selector: 'app-loan-details-form',
  templateUrl: './loan-details-form.component.html',
  styleUrls: ['./loan-details-form.component.scss']
})
export class LoanDetailsFormComponent implements OnInit {
  @Input() transactionInfo:LoanTransactionDetail 
  @Inject(MAT_DIALOG_DATA) protected data: IPopupScreenData
  popupData:any;
  // flag:any;
  constructor( 
  ) {
   
  }
  ngOnInit(): void {
    this.popupData = this.data?.screenData?.data;
    //  this.flag = this.popupData.dbcrFlag;
    // console.log("popupdata",this.flag);
    
  }

}
